<template>
    <div class="container-fluid" v-if="school && department">
        <div class="card">
            <div class="card-body">
                <div class="row justify-content-between">
                    <div class="col">
                        <h4>{{school.name}} {{department.name}} анги > хичээл</h4>
                    </div>

                </div>
            </div>
        </div>
        
        <div class="card shadow my-4">
            <div class="card-header py-3">
                <div class="row">
    
                        <div class="col col-expand">
                            <h6 class="m-0 font-weight-bold text-primary">Хичээлийн жагсаалт</h6>
                        </div>
                        <div class="col col-auto">
                            <div class="col-auto">
                                <!-- <div @click="$router.push({ 'name':'ILessonAdd' , params:{ schoolId: schoolId, setTeacher: true }})" class="btn btn-danger btn-sm mr-2">Хичээл нэмэх</div> -->
                                <div @click="$router.push({ 'name':'ILessonAddGroup' , params:{ schoolId: schoolId, setTeacher: true, categoryId: categoryId }})" class="btn btn-danger btn-sm">Хичээл бxxxагцалж нэмэх</div>
                            </div>
                        </div>
                    

                 
                </div>
            </div>
            <div class="card-body">
   
                <div class="table-responsive" v-if="teachers!=null && teachers.length>0">
                <table class="table table-sm table-bordered" id="dataTable" width="100%" cellspacing="0">
                    <thead>
                    <tr>
                        <th>№</th>
                        <th>Нэр</th>
                        <th>Үйлдэл</th>
                    </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(teacher, index) in teachers" v-bind:key="teacher.id">
                            <td>{{index+1}}</td>
                            <td>{{teacher.name}}</td>
                            <!-- <td>
                                <span class="badge badge-success" v-if="teacher.typeDetail">
                                    {{teacher.typeDetail.name}}
                                </span>
                            </td> -->

                            <td>
                                <button @click="$router.push( { name:'DLessonsByCategory', params:{ schoolId: schoolId, departmentId:departmentId, categoryId: teacher.id } } )" class="btn btn-sm btn-success">харах</button>
                            </td>
                        </tr>
                    
                    </tbody>
                </table>
                    <div v-if="!searched">
                        <button v-if="loading==false" @click="getTeacherData()" class="nextbutton shadow" style=""><i class="fas fa-arrow-down fa-2x" style="color:black!important;height:40; width:40"></i></button>
                        <button v-else type="button" class="btn btn-success btn-block" disabled>
                            <span class="spinner-border spinner-border-sm"></span>
                            Loading..
                        </button>
                    </div>
                </div>
                <div v-else class="alert alert-info text-center">Одоогоор мэдээлэл ороогүй байна.</div>
            </div>
        </div>

    </div>
    
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'
    const fb = require('../../../firebaseConfig.js')

    export default {
        data() {
            return {
               teachers:[],
               lastVisible:null,
               loading:false,
               last:false,
               showSimple:true,
               searchValue:null,
               searched:false,
               searchField:'email',
               pageSize:30,
               school:null,
               department:null
            }
        },
        props: {
            schoolId: { 
                required: true,
            },
            departmentId:{
                required:true
            }
        },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },
        methods: {

            async _getData(){
                var schoolDoc=await fb.db.doc('schools/'+this.schoolId).get();
                if(schoolDoc.exists){
                    let school=schoolDoc.data();
                    school.id=schoolDoc.id;
                    school.ref=schoolDoc.ref;
                    this.school=school
                    this.teachers=[];

                    schoolDoc.ref.collection("departments").doc(this.departmentId).get().then(depDoc=>{
                        if(depDoc.exists){
                            let department=depDoc.data();
                            department.id=depDoc.id;
                            this.department=department;
                        }
                    })
                
                    this.getTeacherData();
                }
                
            },
    
            async getTeacherData(){

                if(this.last==false){
                    this.loading=true;
                    var query;
                    if(this.lastVisible==null)
                    
                        query=fb.db.collection("schools/"+this.schoolId+"/categories").orderBy("index", "asc");
                    
                    else
                        query=fb.db.collection("schools/"+this.schoolId+"/categories").orderBy("index", "asc").startAfter(this.lastVisible);

                    
                    query=query.limit(this.pageSize);
                    if(query!=null){
                        var documentSnapshots=await query.get();
                        this.lastVisible= documentSnapshots.docs[documentSnapshots.docs.length-1];
                        documentSnapshots.forEach(doc=> {
                            let object=doc.data()
                            object.id = doc.id
                            this.teachers.push(object);
                        });
                        if(documentSnapshots.size!=this.pageSize)
                            this.last=true;
                    }
                    this.loading=false;
                }
               
            },

            search(value){
                if(value!=null && value!='' && this.searchField!=null && this.searchField!=''){
                    this.lastVisible=null;
                    this.last=false;
                    this.searched=true;
                    this.teachers=[];
                    this.searchBy(value);
                }
                
            },
            async searchBy(value){
                if(this.searchField=="code")
                    value=value.toLowerCase();
                    this.loading=true;
                    var query;
                    query=fb.db.collection("schools/"+this.schoolId+"/categories").where(this.searchField, "==", value);
                    // if(this.schools!=null){
                    //     query=query.where('school', "in", this.schools)
                    // }

                    if(query!=null){
                        var documentSnapshots=await query.get();
                        documentSnapshots.forEach(doc=> {
                            let object=doc.data();
                            object.id = doc.id;
                            this.teachers.push(object);
                        });

                    }
                    this.loading=false;

            },
            

  
        },
        created() {

            this.teachers=[];
            this._getData();
                
        },

        filters: {
            formatDate(val) {
                if (!val) { return '-' }
                let date = val.toDate()
                return moment(date).fromNow()
            },
            trimLength(val) {
                if (val.length < 200) { return val }
                return `${val.substring(0, 200)}...`
            }
        }
    }
</script>
